import { render } from "./ButtonLogin.vue?vue&type=template&id=0fd08eae&ts=true"
import script from "./ButtonLogin.vue?vue&type=script&lang=ts"
export * from "./ButtonLogin.vue?vue&type=script&lang=ts"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__